import React, { useState } from 'react';

import IntegrationOverviewCard01 from '../../partials/integrations/IntegrationOverviewCard01';
import EditMenu from "../EditMenu";
import LineChart from "../../charts/LineChart01";

function IntegrationsOverview({integrationOverviews, selectedTab, loading}) {

  const [sync, setSync] = useState(false);

  return (
    <div className="flex-grow">
      {/* Panel body */}
        {loading?
            <div>
              <div className="sm:flex justify-items-center mt-10 w-full text-center">
                <div className="m-auto">
                  <svg className="animate-spin h-8 w-8" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="10" fill="transparent" strokeLinecap="round"
                            strokeDasharray="283" strokeDashoffset="75"/>
                  </svg>
                </div>
              </div>
                <div className="sm:flex justify-items-center mt-5 w-full">
                    <div className="animate-bounce m-auto text-center">
                        <p>Just a moment as we retrieve your integrations 🔎</p>
                    </div>
                </div>
            </div>
            :integrationOverviews.length===0?
                <div>
                    <h1 className="mb-8">You don't seem to have any integrations connected 🥺</h1>
                    <p>💡 Select the <i>+Add Integration</i> tab to sync a supported integration.</p>
                </div>:<div className="p-6 space-y-6">
                    <div className="grid grid-cols-12 gap-6">
                        {integrationOverviews.map( (item) => <IntegrationOverviewCard01 key={item.id} overview={item} selectedTab={selectedTab}/>
                        )}
                    </div>
                </div>
        }

    </div>
  );
}

export default IntegrationsOverview;